import React from 'react'
import { Translator } from '@morningtrain/react-translations'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { PageHeader } from 'ui/layouts'
import CardGroup from 'ui/layouts/CardGroup'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import { AmoMeetings } from 'pages/app/hr/amo/meetings'
import { AmoAssessments } from 'pages/app/hr/amo/assessments'
import { AmoMembers } from 'pages/app/hr/amo/members'

export default function Amo (props) {
  return (
    <AdminPageWithSmartview withGlobalDepartmentFilter={false}>
      <Translator namespace='hr.amo'>
        <PageHeader title={<TranslatedTitle name='title' />} />
        <CardGroup>
          <AmoMembers />
          <AmoAssessments />
          <AmoMeetings />
        </CardGroup>
      </Translator>
    </AdminPageWithSmartview>
  )
}
